import React, { useEffect } from "react";
import styled from "styled-components";
import {
  CouponExternal,
  CouponGroupExternal,
} from "../../../ducks/coupon/types";
import { AppCouponItem } from "../../molecules/coupon/AppCouponItem";
import { PopupModalContainer, fadein } from "./PopupModal.styles";

type Props = {
  couponGroup: CouponGroupExternal | null;
  isOpen: boolean;
  getQuantityOfAppliedCoupon: (coupon: CouponExternal) => number;
  handleUse: (coupon: CouponExternal, quantity: number) => void;
  handleClose: () => void;
};

export const AppCouponExternalModal: React.FC<Props> = ({
  couponGroup,
  isOpen,
  handleUse,
  handleClose,
  getQuantityOfAppliedCoupon,
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }

    return () => {
      document.body.classList.remove("overflow-hidden");
    };
  }, [isOpen]);

  if (!isOpen || !couponGroup) return null;

  return (
    <PopupModalContainer $isOpen={isOpen} onClick={handleClose}>
      <ModalContainer $isOpen={isOpen} onClick={(e) => e.stopPropagation()}>
        <ModalHeader>使用するクーポンを選択してください</ModalHeader>

        <ModalContent>
          {couponGroup.coupons.map((coupon) => (
            <AppCouponItem
              key={coupon.code}
              coupon={coupon}
              isUsed={getQuantityOfAppliedCoupon(coupon) > 0}
              usedAmount={getQuantityOfAppliedCoupon(coupon)}
              onUse={() => handleUse(coupon, 1)}
            />
          ))}
        </ModalContent>
      </ModalContainer>
    </PopupModalContainer>
  );
};

const ModalContainer = styled.div<{ $isOpen: boolean }>`
  position: absolute;
  top: 50%;
  left: 50%;
  background-color: white;
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  transform: ${({ $isOpen }) =>
    $isOpen
      ? "translate(-50%, -50%) scale(1, 1)"
      : "translate(-50%, -50%) scale(0.9, 0.9)"};
  animation: ${fadein} 0.5s forwards;
  width: 90%;
  max-width: 600px;
  min-width: 325px;
`;

const ModalHeader = styled.div`
  padding: 25px 0;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  line-height: 100%;
`;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-y: auto;
  padding: 0px 15px;
  text-align: center;
  margin-bottom: 17px;
`;
